import { Component, input, output, signal } from '@angular/core';
import { SettingsSideNavSection, SettingsSideNavItem } from './settings-side-nav.types';

@Component({
  selector: 'app-settings-side-nav',
  standalone: false,
  templateUrl: './settings-side-nav.component.html',
  styleUrl: './settings-side-nav.component.scss'
})
export class SettingsSideNavComponent {
  /**
   * The sections to display in the side nav
   */
  sections = input<SettingsSideNavSection[]>([]);

  /**
   * The currently selected item ID
   */
  selectedItemId = input<string>('');

  /**
   * Emits when a navigation item is clicked
   */
  itemClicked = output<SettingsSideNavItem>();

  /**
   * Controls the mobile drawer visibility
   */
  isDrawerOpen = signal<boolean>(false);

  /**
   * Checks if an item is currently selected
   */
  isSelected(itemId: string): boolean {
    return this.selectedItemId() === itemId;
  }

  /**
   * Handles navigation item click
   */
  onItemClick(item: SettingsSideNavItem): void {
    this.itemClicked.emit(item);
    // Close drawer on mobile after selecting an item
    this.closeDrawer();
  }

  /**
   * Opens the mobile drawer
   */
  openDrawer(): void {
    this.isDrawerOpen.set(true);
  }

  /**
   * Closes the mobile drawer
   */
  closeDrawer(): void {
    this.isDrawerOpen.set(false);
  }

  /**
   * Toggles the mobile drawer
   */
  toggleDrawer(): void {
    this.isDrawerOpen.set(!this.isDrawerOpen());
  }
}
